import React, { forwardRef } from 'react';
import ReactDatePicker from 'react-datepicker';
import setHours from 'date-fns/setHours';
import setMinutes from 'date-fns/setMinutes';
import 'react-datepicker/dist/react-datepicker.css';

import './TimePicker.scss';
import { useState } from 'react';
import bem from '../../utils/bem';

const TimePicker = ({
  value,
  onChange,
  placeholder,
  showTimeInput,
  onBlur,
}) => {
  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <button onClick={onClick} type="button" className="time-picker__input">
      {value || placeholder || ''}
    </button>
  ));

  const [opened, setIsOpened] = useState(false);
  
  return (
    <div className={bem("time-picker", {
      opened: opened
    })}>
      <ReactDatePicker
        selected={value}
        onChange={onChange}
        customInput={<CustomInput />}
        popperPlacement="top-start"
        showTimeSelect
        showTimeSelectOnly
        timeIntervals={15}
        timeCaption="Hora"
        dateFormat="h:mm aa"
        minTime={setHours(setMinutes(new Date(), 0), 8)}
        maxTime={setHours(setMinutes(new Date(), 30), 17)}
        onBlur={onBlur}
        onCalendarOpen={() => {
          setIsOpened(true);
        }}
        onCalendarClose={() => {
          setIsOpened(false);
        }}
      />
    </div>
  );
};
TimePicker.defaultProps = {
  onBlur: () => {},
};

export default TimePicker;
